import {
  RiLineChartLine,
  RiPulseLine,
  RiGroup3Line,
  RiArchiveLine,
} from '@remixicon/react';
import { useCurrentStore } from '@/hooks/useCurrentStore';
import { KpiCard } from '@/components/dashboard/shared/KpiCard';

interface StatsGridProps {
  stats?: {
    totalRevenue?: number;
    totalOrders?: number;
    totalCustomers?: number;
    totalProducts?: number;
    averageOrderValue?: number;
    conversionRate?: number;
    growthRate?: number;
  };
}

export function StatsGrid({ stats }: StatsGridProps) {
  const { currentStore } = useCurrentStore();
  const currency = currentStore?.currency || 'NGN';

  return (
    <>
      <KpiCard
        label="Total Revenue"
        value={stats?.totalRevenue || 0}
        currency={currency}
        icon={<RiLineChartLine />}
        trendPercent={stats?.growthRate}
      />
      <KpiCard
        label="Total Orders"
        value={stats?.totalOrders || 0}
        icon={<RiPulseLine />}
      />
      <KpiCard
        label="Total Customers"
        value={stats?.totalCustomers || 0}
        icon={<RiGroup3Line />}
      />
      <KpiCard
        label="Total Products"
        value={stats?.totalProducts || 0}
        icon={<RiArchiveLine />}
      />
    </>
  );
}
